import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Product, ProductVariant } from '@interfaces/product'

interface WishlistItem {
  product: Product
  selectedVariant: ProductVariant
}

interface WishlistState {
  items: WishlistItem[]
}

const loadWishlistFromLocalStorage = (): WishlistState => {
  try {
    const serializedState = localStorage.getItem('wishlist')
    if (serializedState === null) {
      return { items: [] }
    }
    return JSON.parse(serializedState)
  } catch (err) {
    console.error('Failed to load wishlist from localStorage:', err)
    return { items: [] }
  }
}

const saveWishlistToLocalStorage = (state: WishlistState) => {
  try {
    const serializedState = JSON.stringify(state)
    localStorage.setItem('wishlist', serializedState)
  } catch (err) {
    console.error('Failed to save wishlist to localStorage:', err)
  }
}

const initialState: WishlistState = loadWishlistFromLocalStorage()

export const wishlistSlice = createSlice({
  name: 'wishlist',
  initialState,
  reducers: {
    addToWishlist: (
      state,
      action: PayloadAction<{ product: Product; selectedVariant: ProductVariant }>,
    ) => {
      const { product, selectedVariant } = action.payload
      if (!state.items.some((item) => item.product.id.toString() === product.id.toString())) {
        state.items.push({ product, selectedVariant })
        saveWishlistToLocalStorage(state)
      }
      console.log('Added to wishlist:', product, selectedVariant)
    },
    removeFromWishlist: (state, action: PayloadAction<string>) => {
      state.items = state.items.filter((item) => item.product.id.toString() !== action.payload)
      saveWishlistToLocalStorage(state)
      console.log('Removed from wishlist:', action.payload)
    },
  },
})

export const { addToWishlist, removeFromWishlist } = wishlistSlice.actions

export default wishlistSlice.reducer
